module.exports = __webpack_public_path__ + "img/scene_night_light_big@2x.2c26b111.png";